import React from 'react';
import { Box, Typography } from '@drone-js/core';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';

export interface DepartureCardProps {
    id: number;
    locationDescription: string;
    description: string;
    contentLocale: string;
}

export const Departure: React.FC<DepartureCardProps> = (props) => {
    return (
        <Box key={props.id} mt="8">
            {props.locationDescription && (
                <Typography variant="body-s" mt="8" tag="p" lang={props.contentLocale}>
                    <AgodaMarkdown input={props.locationDescription} />
                </Typography>
            )}
            {props.description && (
                <Typography variant="caption-default" textColor="base.subtle" mt="8" tag="p" lang={props.contentLocale}>
                    <AgodaMarkdown input={props.description} />
                </Typography>
            )}
        </Box>
    );
};
Departure.displayName = 'Departure';
